var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ai-chat-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.3785 56.5784C49.7075 55.8255 58.7317 46.6733 59.4743 35.1837C59.6195 32.9352 59.6195 30.6066 59.4743 28.3582C58.7317 16.8685 49.7075 7.7164 38.3785 6.96332C34.5135 6.70641 30.4783 6.70695 26.6211 6.96332C15.2921 7.7164 6.26802 16.8685 5.52548 28.3582C5.38018 30.6066 5.38018 32.9352 5.52548 35.1837C5.79593 39.3683 7.64662 43.2429 9.82542 46.5146C11.0905 48.805 10.2556 51.6636 8.9379 54.1607C7.98782 55.9612 7.51277 56.8615 7.89419 57.5117C8.27563 58.162 9.12762 58.1829 10.8316 58.2243C14.2014 58.3064 16.4738 57.3509 18.2775 56.0208C19.3005 55.2665 19.812 54.8893 20.1646 54.8459C20.5171 54.8026 21.2109 55.0883 22.5982 55.6598C23.8451 56.1733 25.2928 56.4902 26.6211 56.5784C30.4783 56.8349 34.5135 56.8355 38.3785 56.5784Z",
    fill: "url(#paint0_linear_419_5950)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3125 40.625L25.301 25.6597C25.5567 24.8925 26.2746 24.375 27.0833 24.375C27.892 24.375 28.61 24.8925 28.8657 25.6597L33.8542 40.625M41.9792 24.375V40.625M23.0208 35.2083H31.1458",
    stroke: "#AEF600",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_419_5950",
    x1: 32.4998,
    y1: 6.77084,
    x2: 32.4998,
    y2: 58.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243B55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatIcon);
export default __webpack_public_path__ + "static/media/ai-chat-icon.5c860884c0ab3c6b39dcef3b61188637.svg";
export { ForwardRef as ReactComponent };